/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PatientGuarantorAddress = {
    readonly id?: number;
    street: string | null;
    street2?: string | null;
    city?: string | null;
    state?: string | null;
    zipcode: string | null;
    phone1?: string | null;
    phone2?: string | null;
    /**
     * fax number to be presented on report. No faxes will be sent here by the system.
     */
    fax?: string | null;
    /**
     * The specific name of the US timezone. Please prefer state based options of Alaska and Arizona when appropriate.
     */
    timezone?: PatientGuarantorAddress.timezone | null;
}

export namespace PatientGuarantorAddress {

    /**
     * The specific name of the US timezone. Please prefer state based options of Alaska and Arizona when appropriate.
     */
    export enum timezone {
        US_ALASKA = 'US/Alaska',
        US_ARIZONA = 'US/Arizona',
        US_CENTRAL = 'US/Central',
        US_EASTERN = 'US/Eastern',
        US_HAWAII = 'US/Hawaii',
        US_MOUNTAIN = 'US/Mountain',
        US_PACIFIC = 'US/Pacific',
    }


}
